import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js"
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import UIConfig from "@baseUI/config/UIConfig";
import AddComponent from "@base/utils/AddComponent";
import {GlowFilter} from "@pixi/filter-glow";

export default class FreespinsIntroContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {

    const addElementBitmapText = AddComponent.addElementBitmapText
    // const filters = [new GlowFilter({ distance: 10, outerStrength: 2, color: 0x009977})];


    const shadow = new PIXI.Graphics()
    shadow.interactive = true
    shadow.beginFill(0x000000, 0.6)
    shadow.drawRect(-UIConfig.totalWidth / 2, -2000, 5000, 5000)
    this.addChildAt(shadow, 0)

    this.popuWin = new SpineAnimation('freespin_popup_win')
    this.popuWin.start(['freespin_msg_mask_start', 'freespin_msg_mask_idle'], [false, true])
    this.popuWin.x = 0
    this.popuWin.y = -150
    this.addChild(this.popuWin);

    this.container = new PIXI.Container()
    this.addChild(this.container)
    this.container.y = 60;

    this.ContinueButton = new PIXI.AnimatedSprite([
      PIXI.Texture.from('freeSpin/BackToGameButtonNormal'),
      PIXI.Texture.from('freeSpin/BackToGameButtonOver'),
      PIXI.Texture.from('freeSpin/BackToGameButtonDown')]
    )

    this.ContinueButton.anchor.set(0.5)
    this.ContinueButton.y = 160
    this.container.addChild(this.ContinueButton)
    this.ContinueButton.on('pointerover', () => {
      this.ContinueButton.gotoAndStop(1)
    })

    this.ContinueButton.on('pointerout', () => {
      this.ContinueButton.gotoAndStop(0)
    })

    AddComponent.addElementTextName('freespinsStartButton', this.ContinueButton, [0, 0]) //'freeSpinButton',
    AddComponent.addElementText('youHaveWon', 'youHaveWon', this, [0, -60])
    // AddComponent.addElementText('moreSpins', 'youHaveWon', this, [0,110])

    // this.winText = addElementBitmapText('', {font: {name: 'fontWin', size: '100px'}, align: 'center'}, this, [0, 20], filters)

    this.winText = AddComponent.addElementText('youHaveWon', 'youHaveWon', this, [0, 20])

    Signals.introFreespins.add(this.showFreespinsIntro, this)

    this.hide()
  }

  showFreespinsIntro() {
    this.visible = true
    this.ContinueButton.interactive = true
    this.winText.text = `${Facade.textFactory.getStringByIdentifier('popupFreespins')}: ${Facade.model.amountFreespin}`
    //moreSpinsText.text = Facade.textFactory.getStringByIdentifier('moreSpins')
    // Tweenlite.to(this.bitmapFontText.scale, 3.3, {x: this.FINISH_SCALE, y: this.FINISH_SCALE, ease: Power2.easeOut, onUpdate: () => {
    //     this.forceCenter()
    //   }, onComplete: () => {
    // //    this.moveDown ()
    //   }})
    this.ContinueButton.once('pointerdown', this.introFreespinsComplete.bind(this))
    //Facade.soundManager.play('gh_popup_freespins', 1, false, 'default')
  }

  hide() {
    this.visible = false
  }

  introFreespinsComplete() {
    this.hide()
    this.ContinueButton.gotoAndStop(2)
    this.ContinueButton.interactive = false
    Signals.introFreespinsComplete.dispatch()
  }

}
